<template>
  <div :id="id" class="dean-input-select-time">
    <div class="dean-input-select-time-field">
      <!-- HOURS -->
      <div class="dean-select">
        <select
          :id="'select-hours-' + id"
          :title="id"
          v-model="selectedHour"
          :disabled="disabled"
        >
          <option class="empty-time" value="" disabled>- -</option>
          <option v-for="item in hours" :value="item" :key="item">{{
            item
          }}</option>
        </select>
      </div>
      <div class="double-point">
        <span>:</span>
      </div>
      <!-- MINUTES -->
      <div class="dean-select">
        <select
          :id="'select-minutes-' + id"
          :title="id"
          v-model="selectedMinute"
          :disabled="disabled"
        >
          <option class="empty-time" value="" disabled>- -</option>
          <option v-for="item in minutes" :value="item" :key="item">{{
            item
          }}</option>
        </select>
      </div>
      <!-- ICON -->
      <!--
    <div v-if="icon" class="dean-input-select-time-icon">
      <dean-icon 
        class="icon" 
        :glyph="clockIcon">
      </dean-icon> 
    </div>
    --></div>
  </div>
</template>

<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import deanIcon from './deanIcon.vue';

// SVG
import clockIcon from '../svg/feather-icons/clock.svg';

// COMPONENTS
@Component({
  components: {
    deanIcon
  }
})
export default class deanInputSelectTime extends Vue {
  // PROPS
  @Prop({ default: 'deanInputSelect' }) id!: string;
  @Prop() icon!: boolean;
  @Prop({ default: 0 }) hour!: number;
  @Prop({ default: 0 }) minute!: number;
  @Prop({ default: false }) disabled!: boolean;

  // DATA
  selectedHour: string = '';
  selectedMinute: string = '';

  data = {
    id: this.id,
    hour: 0,
    minute: 0
  };

  clockIcon: object = clockIcon;

  hours = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23'
  ];

  minutes = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59'
  ];

  @Watch('selectedHour')
  selectedHourChanged() {
    this.data.hour = Number(this.selectedHour);
    this.$emit('selected', this.data);
  }

  @Watch('selectedMinute')
  selectedMinuteChanged() {
    this.data.minute = Number(this.selectedMinute);
    this.$emit('selected', this.data);
  }

  @Watch('hour')
  hourChanged() {
    this.updateTime();
  }

  @Watch('minute')
  minuteChanged() {
    this.updateTime();
  }

  // METHODS
  updateTime() {
    if (String(this.hour) != '') {
      if (this.hour < 10) {
        this.selectedHour = '0' + this.hour;
      } else {
        this.selectedHour = String(this.hour);
      }
    }

    if (String(this.minute) != '') {
      if (this.minute < 10) {
        this.selectedMinute = '0' + this.minute;
      } else {
        this.selectedMinute = String(this.minute);
      }
    }
  }

  mounted() {
    this.updateTime();
  }
}
</script>

<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';
.dean-input-select-time {
  padding: 5px 10px 5px 10px;
  width: 100%;

  .dean-input-select-time-field {
    display: inline-flex;
    position: relative;
    align-items: flex-start;
    justify-content: flex-start;
    @include border-radius(10px);
    border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
    background: white;
    width: 100%;
    height: 42px;
    padding: 0px 10px 0px 10px;

    .dean-input-select-time-icon {
      display: inline-flex;
      position: relative;
      padding: 10px;

      .icon {
        height: 20px;
        fill: var(--color-dark-shade-4, $color-dark-shade-4);
      }
    }

    .dean-select {
      display: inline-flex;
      position: relative;
      justify-content: center;
      align-items: center;
      padding: 0px 2.5px 0px 2.5px;
      font-size: 12pt;

      &:before {
        position: absolute;
        top: 5px;
        content: '';
        width: 0px;
        height: 0px;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-bottom: 3px solid var(--color-dark-shade-4, $color-dark-shade-4);
      }

      &:after {
        position: absolute;
        bottom: 6px;
        content: '';
        width: 0px;
        height: 0px;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-top: 3px solid var(--color-dark-shade-4, $color-dark-shade-4);
      }

      select {
        display: inline-flex;
        align-items: center;
        height: 40px;
        cursor: pointer;
        margin: 0;
        border: 0;
        background: white;
        @include transition(all ease 0.4s);
        font-weight: 500;
        font-style: italic;

        &:hover:enabled {
          outline: none;
          color: var(--color-link, $color-link);
        }

        &:disabled {
          color: var(--color-dark-shade-4, $color-dark-shade-4);
          font-weight: 500;
          cursor: not-allowed;
        }
      }

      select:hover + &:after {
        border-top: 4px solid var(--color-link, $color-link);
      }
    }

    .double-point {
      display: inline-flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      font-size: 12pt;
      width: 5px;
    }
  }
}
</style>
